import BaseMapConfig from "./BaseMapConfig.js";
import leafletImage from 'leaflet-image';

/**
 * Canvas-based map subclass
 */
export default class CanvasMap extends BaseMapConfig {
    constructor(containerId, center, zoom) {
        super(containerId, center, zoom);
        this.canvasRenderer = L.canvas({ padding: 0.5 });

        // Patch to support fillPattern
        const orig = L.Canvas.prototype._fillStroke;
        L.Canvas.include({
            _fillStroke: function (ctx, layer) {
                const o = layer.options;
                if (o.fill && o.fillPattern) {
                    ctx.globalAlpha = o.fillOpacity || 1.0;
                    ctx.fillStyle = o.fillPattern;
                    ctx.fill();
                } else if (o.fill) {
                    ctx.globalAlpha = o.fillOpacity || 1.0;
                    ctx.fillStyle = o.fillColor || o.color;
                    ctx.fill();
                }

                if (o.stroke && o.weight !== 0) {
                    ctx.globalAlpha = o.opacity || 1.0;
                    ctx.strokeStyle = o.color;
                    ctx.lineWidth = o.weight;
                    ctx.lineCap = o.lineCap || 'round';
                    ctx.lineJoin = o.lineJoin || 'round';
                    ctx.stroke();
                }
            }
        });
    }

    /**
     * Add a cadastre parcel using Canvas renderer and patterns
     */
    async addCadastre({ code_insee, section, numero, surface, commentaire, status, nature_de_la_terre, donnees_api_cadastre }) {
        let data = donnees_api_cadastre;
        if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch { console.error('JSON parse error'); return; }
        }
        if (!data.features?.length) return;

        const colorMap = { bati: 'rgba(227, 205, 39,1)', bois: 'rgba(133, 52, 147,1)', herbage: 'rgba(52, 147, 76,1)', labour: 'rgba(150, 100, 60,1)', marais: 'rgba(17, 153, 188,1)', autre: 'rgba(209, 123, 37,1)' };
        const fillMap = { bati: 'rgba(227, 205, 39,0.3)', bois: 'rgba(133, 52, 147,0.3)', herbage: 'rgba(52, 147, 76,0.3)', labour: 'rgba(150, 100, 60,0.3)', marais: 'rgba(17, 153, 188,0.3)', autre: 'rgba(209, 123, 37,0.3)' };
        const baseColor = colorMap[nature_de_la_terre?.value] || '#000';
        const baseFill = fillMap[nature_de_la_terre?.value] || 'rgba(0,0,0,0.3)';

        const layer = L.geoJSON(data, {
            renderer: this.canvasRenderer,
            style: (f) => {
                if (status?.value === 'locataire') {
                    return { fillPattern: this._createPattern(baseFill, baseColor), weight: 2, opacity: 1, fill: true, color: baseColor, fillOpacity: 1 };
                }
                return { color: baseColor, fillColor: baseFill, weight: 2, opacity: 1, fillOpacity: 1 };
            },
            onEachFeature: (f, lyr) => {
                const popup = `...`; // same as SVG
                lyr.bindPopup(popup);
            }
        }).addTo(this.map);

        this.boundsGlobal.extend(layer.getBounds());
    }

    _createPattern(fillColor, strokeColor) {
        const size = 8;
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = size;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = fillColor; ctx.fillRect(0, 0, size, size);
        ctx.strokeStyle = strokeColor; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(0, size); ctx.stroke();
        return ctx.createPattern(canvas, 'repeat');
    }

    /**
     * Export map as PNG and insert into #caca container
     */
    _exportAsImage() {
        leafletImage(this.map, (err, canvas) => {
            if (err) { console.error(err); return; }
            const img = document.createElement('img');
            img.src = canvas.toDataURL('image/png');
            img.alt = 'Carte en image';
            img.style.maxWidth = '100%';
            const holder = document.getElementById('pdf-img-map');
            if (holder) {
                holder.innerHTML = '';
                holder.appendChild(img);
            }
        });
    }
}